import {DynamicTable} from '../../../../components/DynamicTable'
import {outOfStockOccurrenceDetailsTableColumns} from '../../utils'
import OutOfStockOccurrenceDetailsTableRow from './OutOfStockOccurrenceDetailsTableRow'

const OutOfStockOccurrenceDetailsTable = ({
  isParentRow,
  productVariants,
  isOperationLoading,
}: any) => {
  return (
    <div className='popup-inquiry-table'>
      <DynamicTable
        data={productVariants}
        sortableColumns={outOfStockOccurrenceDetailsTableColumns(isParentRow)}
        loading={isOperationLoading}
        tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
        TableRow={OutOfStockOccurrenceDetailsTableRow}
        tableRowProps={{isParentRow}}
      />
    </div>
  )
}
export default OutOfStockOccurrenceDetailsTable
